import React from 'react'
import styled from 'styled-components'
import { novelNotices, rewardNotices, withdrawalNotices } from '../constants'
import { Box, Image, Text } from '../../../designSystem'
import MilestoneTrophyGuy from "../../../components/Images/MilestoneTrophyGuy"
import CrossIcon from '../../../components/Images/CrossIcon'
import CardGraphic from './WBWithdrawReqIcon'


const WriterNotification = styled.div`
  display: ${({ hide }) => hide ? 'none' : 'grid'};
  grid-template-columns: 3.5rem auto;
  gap: 0rem 0.6rem;
  align-items: stretch;
  background-color: ${({ theme }) => theme.colors.surface.foreground};
  color: ${({ theme }) => theme.colors.text.text700};
  padding: 0.5rem 1rem;
  margin:0rem auto 0.5rem;
  border-left: ${props => "0.4rem solid var("+props.statusColor+");"};
  position: relative;
  transition: all 0.2s;
  margin: 8px;
  padding: 8px;
  border-radius: 8px;
  // max-width: 35rem;
  &:hover {
    box-shadow: 8px 8px 16px 8px rgba(73, 83, 89, 0.16);
  }
  @media (max-width: 600px) {
    grid-template-columns: 2.5rem auto;
    // grid-auto-rows: 3.5rem;
  }
`

const NotificationCloseBtn = styled.button`
  all:unset;
  position:absolute;
  top:8px;
  right:8px;
  cursor:pointer;
  display:flex;
  justify-content: center;
  align-items: center;
`

const detailsHeading = {
  color: 'inherit',
  fontSize: 'D.XS',
  fontWeight: 'b',
  lineHeight: '1.43'
}

const detailsMoreInfo = {
  color: 'text.text500',
  mx: 'auto',
  my: '0.2rem',
  fontSize: 'D.XXS',
  lineHeight: '1.5'
}
const DetailsActionBtn = styled.button`
  all: unset;
  font-size: 9px;
  color: var(${props => props.btnTextColor ? props.btnTextColor : '--Text500' });
  font-weight: bold;
  height: 2rem;
  padding: 0.2rem 0.8rem;
  cursor: pointer;
  border-radius: 4px;
  text-transform: capitalize;
  background-color: var(${props => props.btnBgColor ? props.btnBgColor : '--LD10'});
  transition: all 0.2s;
`
const SvgIconContainer = styled.div` 
  svg{
    width:4rem;
    height:100%;
    transition: all 0.2s;
  }
  @media (max-width: 600px) {
    justify-self: end;
    grid-column-start: 2;
    svg{
      width:2.5rem;
    }
  }
`

const NotificatonCard = ({ handleClick = () => null, actionBtnHandler = () => null, id, btnLink, hidden, isWalletNotification, btnTextColor, btnBgColor, program, bookCoverUrl, action_type, no_button, button_text='Okay', toReplace='{{novel_title}}', withReplace, isWriterNotification, actionBtnText, heading, moreInfo, statusColor, closeBtnHandler }) => {
  const entityForConstants = program?.action_on === 'program' ? novelNotices : rewardNotices
  const btnHandler = isWriterNotification ? () => actionBtnHandler(btnLink,actionBtnText,id) : handleClick
    return (
    <WriterNotification statusColor={statusColor} hide={hidden ? 1 : 0}>
      {isWriterNotification && closeBtnHandler && <NotificationCloseBtn onClick={() => closeBtnHandler(id)}><CrossIcon width="14" height="14"/></NotificationCloseBtn>}
      <Image width="100%" objectFit="contain" variant="normal" objectPosition="inherit" src={bookCoverUrl || program?.book_details.image_url} alt="Book Cover"/>
      <Box display="flex" flexDirection="column">
        {heading && <Box><Text {...detailsHeading}>{heading}</Text></Box>} 
        {!heading && !isWalletNotification && <Box><Text>{action_type && entityForConstants[action_type].title.replace(toReplace, withReplace)}</Text></Box>}
        {!heading && isWalletNotification && <Box><Text>{withdrawalNotices[action_type].title.replace(toReplace, withReplace)}</Text></Box>}
        {!isWriterNotification && <Box><Text {...detailsMoreInfo} fontWeight="600">{program?.book_details.book_title}</Text></Box>}
        {moreInfo && <Box><Text {...detailsMoreInfo}>{moreInfo}</Text></Box>}
        {!moreInfo && !isWalletNotification && <Box><Text {...detailsMoreInfo}>{action_type &&  entityForConstants[action_type].message.replace(toReplace, withReplace)}</Text></Box>}
        {!moreInfo && isWalletNotification && <Box><Text {...detailsMoreInfo}>{withdrawalNotices[action_type].message.replace(toReplace, withReplace)}</Text></Box>}
        <Box display="flex" justifyContent="space-between">
          { actionBtnText && <DetailsActionBtn onClick={btnHandler} btnTextColor={btnTextColor} btnBgColor={btnBgColor}>{actionBtnText || button_text}</DetailsActionBtn>}
          {isWriterNotification && <SvgIconContainer><MilestoneTrophyGuy/></SvgIconContainer>}
          {isWalletNotification && <SvgIconContainer><CardGraphic/></SvgIconContainer>}
        </Box>
      </Box>    
    </WriterNotification>
    )
}
export default NotificatonCard
